import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {

  logged: boolean;

  constructor() { }

  ngOnInit(): void {
    this.logged = localStorage.getItem('user') !== null;
  }

}
